import React, { useCallback } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box,
  SelectChangeEvent,
} from '@mui/material';
import PROFILES from '../../../../utils/profiles';
import type { ProfileType } from '../../../../utils/profiles';
import type { Contact } from '../ContactForm';

interface ProfileSelectProps {
  contact: Contact;
  index: number;
  onUpdate: (index: number, field: keyof Contact, value: any) => void;
  errors?: Record<string, any>;
  onBlur?: () => void;
}

const ProfileSelect: React.FC<ProfileSelectProps> = ({ contact, index, onUpdate, errors, onBlur }) => {
  const handleProfileChange = useCallback(
    (e: SelectChangeEvent<ProfileType[]>) => onUpdate(index, 'profiles', e.target.value),
    [onUpdate, index]
  );

  return (
    <FormControl fullWidth variant="standard" error={Boolean(errors?.contacts?.[index]?.profiles)}>
      <InputLabel>Perfil</InputLabel>
      <Select
        multiple
        required
        value={contact.profiles}
        onChange={handleProfileChange}
        onBlur={onBlur}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {(selected as ProfileType[]).map((value) => (
              <Chip 
                key={value} 
                label={PROFILES[value]} 
                size="small" 
              />
            ))}
          </Box>
        )}
        error={Boolean(errors?.contacts?.[index]?.profiles)}
      >
        {(Object.keys(PROFILES) as ProfileType[]).map((profileKey) => (
          <MenuItem 
            key={profileKey} 
            value={profileKey}
            sx={{
              backgroundColor: contact.profiles.includes(profileKey) ? '#e8f5e9' : 'inherit',
              '&:hover': {
                backgroundColor: contact.profiles.includes(profileKey) ? '#e8f5e9' : 'inherit',
              }
            }}
          >
            {PROFILES[profileKey]}
          </MenuItem>
        ))}
      </Select>
      {errors?.contacts?.[index]?.profiles && (
        <Box sx={{ color: 'error.main', fontSize: '0.75rem', mt: 0.5 }}>
          {errors.contacts[index].profiles}
        </Box>
      )}
    </FormControl>
  );
}; 

export default ProfileSelect; 
